import { cellToBoundary } from "h3-js"

export const getWrappedBoundary = (h3Index) => {
  const coords = cellToBoundary(h3Index)
  
  // Choose a reference longitude (the first point)
  const refLng = coords[0][1]
  
  return coords.map(([lat, lng]) => {
    let wrappedLng = lng
    
    // If this point is > 180 degrees away from our reference, 
    // it's on the other side of the date line. Shift it.
    if (lng - refLng > 180) wrappedLng -= 360
    if (lng - refLng < -180) wrappedLng += 360
    
    return [lat, wrappedLng]
  })
}
